import { User } from 'models/user.model';
import apiClient from './base';

export const login = async (): Promise<User> => {
  const { data } = await apiClient.get('/auth/me');

  return data;
};

export const logout = async (): Promise<User> => {
  const { data } = await apiClient.get('/auth/logout');

  return data;
};

export const redirectToAuth = async () => {
  const authURL = process.env.REACT_APP_SSO_AUTH_URL;
  const urlParams = new URLSearchParams({
    redirect_uri: process.env.REACT_APP_SSO_REDIRECT_URI,
    client_id: process.env.REACT_APP_SSO_CLIENT_ID,
    response_type: 'code',
    scope: ['profile', 'email', 'openid'].join(' '),
  });

  window.location.href = `${authURL}?${urlParams.toString()}`;
};
